import { useCallback, useMemo } from 'react'
import { ConvertConfig as ConvertConfigLib, GetCurrenciesReturn } from '@web/walter-lib/api/types'
import { useCurrencies, useTransferConvertConfig } from '~api'

/**
 * Convert config
 */
export interface ConvertConfig {
    [asset: string]: Set<string> | undefined
}

const processTransferConvertConfig = (config?: ConvertConfigLib, currencies?: GetCurrenciesReturn) => {
    if (!config || !currencies) {
        return {}
    }

    const convertConfig: ConvertConfig = {}
    config?.forEach(item => {
        const from = item.currencyFrom
        const to = item.currencyTo
        if (currencies[from]) {
            if (convertConfig[from]) {
                convertConfig[from]?.add(to)
            } else {
                convertConfig[from] = new Set([to])
            }
        }
    })

    return convertConfig
}

export const useConvertConfig = () => {
    const { data: transferConvertConfig, isValidating: isConvertConfigLoading } = useTransferConvertConfig()
    const { data: currencies, isValidating: isCurrenciesLoading } = useCurrencies()

    const convertConfig = useMemo(
        () => processTransferConvertConfig(transferConvertConfig, currencies),
        [transferConvertConfig, currencies]
    )

    const checkIfPairConvertable = useCallback(
        (fromCode: string, toCode: string) => !!convertConfig[fromCode]?.has(toCode),
        [convertConfig]
    )

    return {
        data: convertConfig,
        checkIfPairConvertable,
        isLoading: isConvertConfigLoading || isCurrenciesLoading,
    }
}
